import { EditorContent, useEditor } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import './index.css';

// 一个只读的富文本渲染组件，用于展示反馈内容
export default function ReadOnlyFeedbackContentEditor({ value }: { value: string }) {
  const editor = useEditor({
    editable: false,
    extensions: [StarterKit],
    content: value,
  });

  return <EditorContent editor={editor} />;
}
